module.exports = __webpack_public_path__ + "img/h5_block02.4be1bdb4.webp";